attribute float aIndex;
attribute vec3 aStartPosition;
attribute vec3 aEndPosition;
attribute vec3 aTextPosition;
uniform float uTime;
uniform float uPointSize;
uniform float uAnimationProgress;

varying float vProgress;

void main() {
  float changePointStart = 0.15;
  float changePointEnd = 0.5;
  float stayTime = aIndex / 20000.0;
  float progress = max(0.0, uAnimationProgress - stayTime);
  vProgress = smoothstep(0.0, 1.0, progress);

  vec3 pos = vec3(0.0,0.0,0.0);
  float startProgress = smoothstep(0.0,changePointStart,vProgress);
  float endProgress = smoothstep(changePointEnd,1.0,vProgress);

  if(vProgress < changePointStart) {
   pos = mix(aStartPosition, aTextPosition, startProgress);
  } else if(vProgress > changePointEnd) {
    pos = mix(aTextPosition, aEndPosition, endProgress);
  } else {
    pos = aTextPosition;
  }

  gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
  gl_PointSize = uPointSize;
}